var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-combobox',_vm._g(_vm._b({attrs:{"outlined":"","persistent-placeholder":""},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var item = ref.item;
return [_vm._t("selection",function(){return [_c('v-chip',[_vm._v(_vm._s(item)+" ")])]},{"item":item})]}}],null,true)},'v-combobox',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }